// import React, { useState, useEffect } from "react";
// import { signIn, getCurrentUser, signInWithRedirect, signOut } from "@aws-amplify/auth";
// import { Link, useNavigate } from "react-router-dom";
// import toastr from "toastr";
// import { FaFacebook, FaTwitter, FaGithub, FaGoogle } from 'react-icons/fa';
// import { FaEye, FaEyeSlash } from "react-icons/fa";
// import Layout from "../layout/Layout";
// import { fetchAuthSession } from 'aws-amplify/auth';
// const LoginPage = () => {
//   const [username, setUsername] = useState("");
//   const [password, setPassword] = useState("");
//   const [passwordVisible, setPasswordVisible] = useState(false);
//   const [rememberMe, setRememberMe] = useState(false);
//   const navigate = useNavigate();
//   const [loading, setLoading] = useState(false);

//   const togglePasswordVisibility = () => {
//     setPasswordVisible(!passwordVisible);
//   };

//   useEffect(() => {
//     const checkUser = async () => {
//       try {
//         const user = await getCurrentUser();
//         if (user) {
//           navigate("/pricing");
//         }
//       } catch { }
//     };

//     checkUser();
//   }, [navigate]);
//   const handleGoogleSignIn = () => {
//     signInWithRedirect({ provider: "google" });
//   };

//   const handleGitHubSignIn = () => {
//     signInWithRedirect({ provider: "github" });
//   };

//   const handleLogin = async (e) => {
//     e.preventDefault();
//     if (!username || !password) {
//       toastr.error("Username and password are required");
//       return;
//     }
//     setLoading(true);
//     console.time('Total Login');

//     try {
//       try {
//         await getCurrentUser();
//         await signOut();
//       } catch (e) { }
      
//       console.time('SignIn');
//       const signInResult = await signIn({ username, password });
//       console.timeEnd('SignIn');
      
//       if (signInResult.nextStep?.signInStep === 'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED') {
//         sessionStorage.setItem('tempUsername', username);
//         sessionStorage.setItem('tempSignInResult', JSON.stringify(signInResult));
//         await signOut();
//         navigate('/reset-password');
//         return;
//       }
      
//       // Get tenantID from JWT token payload
//       const session = await fetchAuthSession();
//       const tenantID = session.tokens?.idToken?.payload['custom:tenantID'];
//       if (!tenantID) throw new Error("User has no tenant ID");
      
//       sessionStorage.clear();
      
//       console.time('TenantAPI');
//       const tenantApiUrl = process.env.REACT_APP_TENANT_API;
//       const response = await fetch(`${tenantApiUrl}/v2/tenant/settings?tenantID=${tenantID}`);
//       if (!response.ok) throw new Error("Failed to fetch user data from API.");
//       const responseData = await response.json();
//       console.timeEnd('TenantAPI');

//       localStorage.setItem("tenantID", tenantID);
//       localStorage.removeItem("organizationID");

//       Object.entries(responseData).forEach(([key, value]) => {
//         const modifiedKey = key === "subscriptionPlan" ? "selectedPlan" 
//           : key === "cloudAccounts" ? "connectedAccounts" 
//           : key;

//         const sanitizedValue = typeof value === "object" ? JSON.stringify(value) 
//           : typeof value === "string" ? value.replace(/^"(.*)"$/, "$1") 
//           : value;

//         localStorage.setItem(modifiedKey, sanitizedValue);
//       });

//       const selectedPlan = JSON.parse(localStorage.getItem("selectedPlan") || "{}");
//       const connectedAccounts = JSON.parse(localStorage.getItem("connectedAccounts") || "{}");
//       const hasConnectedAccounts = (connectedAccounts?.aws?.length > 0 || connectedAccounts?.organizations?.length > 0);

//       console.timeEnd('Total Login');
      
//       toastr.success("Login successful!");
      
//       if (selectedPlan.name === "Basic" && selectedPlan.billingType === "Monthly" && selectedPlan.price === "0") {
//         window.location.href = "/pricing";
//       } else if (!hasConnectedAccounts) {
//         window.location.href = "/dashboard/connected-accounts";
//       } else {
//         window.location.href = "/dashboard/home";
//       }
//     } catch (error) {
//       console.log(error);
//       toastr.error(error.message || "Something went wrong during sign-in.");
//     } finally {
//       setLoading(false); // Reset loading state regardless of success or error
//     }
//   };



//   return (
//     <Layout>
//       <div className="position-absolute top-0 start-0 m-4 d-flex align-items-center">
//         <img
//           src="/images/odir-logo.png"
//           alt="ODIR Logo"
//           style={{ height: "40px", width: "auto" }}
//         />
//         <span className="ms-2 fw-bold" style={{ fontSize: "1.5rem", color: "#342ead" }}>ODIR</span>
//       </div>
//       <div className="container-fluid">
//         <div className="row h-100">
//           {/* Left Section */}
//           <div className="col-lg-8 col-md-6 col-sm-12 position-relative d-flex align-items-center">
//             <div className="text-center w-100 px-5">
//               <h1 className="display-4 fw-bold mb-4" style={{ color: "#342ead" }}>
//                 Bringing Order to Your Cloud
//               </h1>
//               <p className="lead fs-4 text-muted">
//                 Optimize, secure, and visualize your multi-cloud environment with AI-powered insights and automation
//               </p>
//             </div>
//           </div>

//           {/* Right Section */}
//           <div className="col-lg-4 col-md-6 col-sm-12 right-section">
//             <div className="form mx-auto">
//               <h3>Welcome</h3>
//               <p>Please sign in to your account and start the adventure</p>
//               <form onSubmit={handleLogin}>
//                 <div className="mb-3">
//                   <input
//                     type="text"
//                     id="username"
//                     className="form-control"
//                     placeholder="Email"
//                     value={username}
//                     onChange={(e) => setUsername(e.target.value)}
//                   />
//                 </div>

//                 <div className="mb-3">
//                   <div className="input-group">
//                     <input
//                       type={passwordVisible ? "text" : "password"}
//                       id="password"
//                       className="form-control"
//                       placeholder="Password"
//                       value={password}
//                       onChange={(e) => setPassword(e.target.value)}
//                     />
//                     <button
//                       type="button"
//                       className="btn btn-outline-secondary"
//                       onClick={togglePasswordVisibility}
//                     >
//                       {passwordVisible ? <FaEyeSlash /> : <FaEye />}
//                     </button>
//                   </div>
//                 </div>

//                 <div className="RememberMe d-flex justify-content-between align-items-center mb-3">
//                   <div>
//                     <input
//                       type="checkbox"
//                       id="rememberMe"
//                       checked={rememberMe}
//                       onChange={(e) => setRememberMe(e.target.checked)}
//                       className="custom-checkbox"
//                     />
//                     <label htmlFor="rememberMe" className="ms-2">
//                       Remember Me
//                     </label>
//                   </div>

//                   <Link to="/forgot-password" className="forgetPassword">
//                     Forgot Password?
//                   </Link>
//                 </div>

//                 <button
//                   type="submit"
//                   className="btn btn-Login-Signup w-100"
//                   disabled={loading}
//                 >
//                   {loading ? "Please Wait..." : "LOGIN"}
//                 </button>
//               </form>

//               <p className="mt-4 text-center">
//                 New on our platform?{" "}
//                 <Link to="/register" className="primary-text">
//                   Create an account
//                 </Link>
//               </p>

//               <div class="centered-hr">
//                 <span>or</span>
//               </div>

//               <div className="social-icons d-flex justify-content-center">
//                 {/* <a href="#" title="Sign in with Facebook" style={{ color: '#4267B2' }}>
//                 <FaFacebook />
//               </a>
//               <a href="#" title="Sign in with Twitter" style={{ color: '#1DA1F2' }}>
//                 <FaTwitter />
//               </a> */}
//                 <a href="#" title="Sign in with GitHub" style={{ color: '#333' }}>
//                   <FaGithub />
//                 </a>
//                 <a href="#" title="Sign in with Google" style={{ color: '#DB4437' }}>
//                   <FaGoogle />
//                 </a>
//               </div>

//             </div>
//           </div>
//         </div>
//       </div>
//     </Layout>
//   );
// };

// export default LoginPage;
import React, { useState, useEffect } from "react";
import { signIn, getCurrentUser, signInWithRedirect, signOut } from "@aws-amplify/auth";
import { Link, useNavigate } from "react-router-dom";
import toastr from "toastr";
import { FaGithub, FaGoogle } from 'react-icons/fa';
import { FaEye, FaEyeSlash } from "react-icons/fa";
import Layout from "../layout/Layout";
import { fetchAuthSession } from 'aws-amplify/auth';

const LoginPage = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  /**
   * 🔐 If user is already logged in,
   * redirect directly to Dashboard (NOT pricing page)
   */
  useEffect(() => {
    const checkUser = async () => {
      try {
        const user = await getCurrentUser();
        if (user) {
          navigate("/dashboard/home"); // ✅ go to dashboard directly
        }
      } catch {
        // user not logged in, do nothing
      }
    };

    checkUser();
  }, [navigate]);

  const handleGoogleSignIn = () => {
    signInWithRedirect({ provider: "google" });
  };

  const handleGitHubSignIn = () => {
    signInWithRedirect({ provider: "github" });
  };

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!username || !password) {
      toastr.error("Username and password are required");
      return;
    }

    setLoading(true);
    console.time("Total Login");

    try {
      /**
       * Ensure clean auth state before login
       */
      try {
        await getCurrentUser();
        await signOut();
      } catch {}

      console.time("SignIn");
      const signInResult = await signIn({ username, password });
      console.timeEnd("SignIn");

      /**
       * Handle NEW PASSWORD required flow
       */
      if (signInResult.nextStep?.signInStep === "CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED") {
        sessionStorage.setItem("tempUsername", username);
        sessionStorage.setItem("tempSignInResult", JSON.stringify(signInResult));
        await signOut();
        navigate("/reset-password");
        return;
      }

      /**
       * Fetch user attributes from JWT token
       */
      const session = await fetchAuthSession();
      const idTokenPayload = session.tokens?.idToken?.payload;
      const tenantID = idTokenPayload["custom:tenantID"];
      const userType = idTokenPayload["custom:userType"];

      sessionStorage.clear();

      /**
       * 🏢 COMPANY USER LOGIN FLOW
       * If custom:userType === "company", redirect to company dashboard
       * Note: companyID is stored in custom:tenantID field
       */
      if (userType === "company") {
        if (!tenantID) {
          throw new Error("Company user missing companyID in tenantID field");
        }

        // Store company user session data
        localStorage.setItem("userType", "company");
        localStorage.setItem("companyID", tenantID); // tenantID field contains companyID
        localStorage.removeItem("tenantID"); // Clear tenantID to avoid confusion
        
        console.timeEnd("Total Login");
        toastr.success("Login successful! Welcome to your company portal.");
        
        // Redirect to company dashboard
        window.location.href = "/company/dashboard";
        return;
      }

      /**
       * 🏢 MSP USER LOGIN FLOW (if custom:userType === "msp")
       * MSP users should go to their MSP portal
       */
      if (userType === "msp") {
        // MSP flow - handled separately (not part of this task)
        // For now, just ensure we don't break MSP login
        toastr.error("MSP users should login via their dedicated portal");
        return;
      }

      /**
       * 🏠 TENANT USER LOGIN FLOW (default)
       * If no userType or userType === "tenant", use existing tenant flow
       */
      if (!tenantID) {
        throw new Error("User has no tenant ID");
      }

      /**
       * Fetch tenant settings from backend
       */
      console.time("TenantAPI");
      const tenantApiUrl = process.env.REACT_APP_TENANT_API;
      const response = await fetch(
        `${tenantApiUrl}/v2/tenant/settings?tenantID=${tenantID}`
      );

      if (!response.ok) {
        throw new Error("Failed to fetch user data from API.");
      }

      const responseData = await response.json();
      console.timeEnd("TenantAPI");

      /**
       * Store tenant data in localStorage
       */
      localStorage.setItem("tenantID", tenantID);
      localStorage.removeItem("organizationID");

      Object.entries(responseData).forEach(([key, value]) => {
        const modifiedKey =
          key === "subscriptionPlan"
            ? "selectedPlan"
            : key === "cloudAccounts"
            ? "connectedAccounts"
            : key;

        const sanitizedValue =
          typeof value === "object"
            ? JSON.stringify(value)
            : typeof value === "string"
            ? value.replace(/^"(.*)"$/, "$1")
            : value;

        localStorage.setItem(modifiedKey, sanitizedValue);
      });

      const selectedPlan = JSON.parse(localStorage.getItem("selectedPlan") || "{}");
      const connectedAccounts = JSON.parse(
        localStorage.getItem("connectedAccounts") || "{}"
      );

      const hasConnectedAccounts =
        connectedAccounts?.aws?.length > 0 ||
        connectedAccounts?.organizations?.length > 0;

      console.timeEnd("Total Login");
      toastr.success("Login successful!");

      /**
       * 🚫 PRICING / PLAN PAGE LOGIC (COMMENTED OUT)
       * -------------------------------------------
       * Requirement:
       * - Do NOT show pricing / plan page after login
       * - Always go to dashboard flow
       */

      /*
      if (
        selectedPlan.name === "Basic" &&
        selectedPlan.billingType === "Monthly" &&
        selectedPlan.price === "0"
      ) {
        window.location.href = "/pricing";
      }
      */

      /**
       * ✅ Updated navigation logic (pricing skipped)
       */
      if (!hasConnectedAccounts) {
        window.location.href = "/dashboard/connected-accounts";
      } else {
        window.location.href = "/dashboard/home";
      }

    } catch (error) {
      console.error(error);
      toastr.error(error.message || "Something went wrong during sign-in.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <div className="position-absolute top-0 start-0 m-4 d-flex align-items-center">
        <img
          src="/images/odir-logo.png"
          alt="ODIR Logo"
          style={{ height: "40px", width: "auto" }}
        />
        <span
          className="ms-2 fw-bold"
          style={{ fontSize: "1.5rem", color: "#342ead" }}
        >
          ODIR
        </span>
      </div>

      <div className="container-fluid">
        <div className="row h-100">
          {/* Left Section */}
          <div className="col-lg-8 col-md-6 col-sm-12 d-flex align-items-center">
            <div className="text-center w-100 px-5">
              <h1 className="display-4 fw-bold mb-4" style={{ color: "#342ead" }}>
                Bringing Order to Your Cloud
              </h1>
              <p className="lead fs-4 text-muted">
                Optimize, secure, and visualize your multi-cloud environment
                with AI-powered insights and automation
              </p>
            </div>
          </div>

          {/* Right Section */}
          <div className="col-lg-4 col-md-6 col-sm-12 right-section">
            <div className="form mx-auto">
              <h3>Welcome</h3>
              <p>Please sign in to your account and start the adventure</p>

              <form onSubmit={handleLogin}>
                <div className="mb-3">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Email"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                  />
                </div>

                <div className="mb-3">
                  <div className="input-group">
                    <input
                      type={passwordVisible ? "text" : "password"}
                      className="form-control"
                      placeholder="Password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                    <button
                      type="button"
                      className="btn btn-outline-secondary"
                      onClick={togglePasswordVisibility}
                    >
                      {passwordVisible ? <FaEyeSlash /> : <FaEye />}
                    </button>
                  </div>
                </div>

                <div className="d-flex justify-content-between mb-3">
                  <div>
                    <input
                      type="checkbox"
                      checked={rememberMe}
                      onChange={(e) => setRememberMe(e.target.checked)}
                    />
                    <label className="ms-2">Remember Me</label>
                  </div>

                  <Link to="/forgot-password">Forgot Password?</Link>
                </div>

                <button
                  type="submit"
                  className="btn btn-Login-Signup w-100"
                  disabled={loading}
                >
                  {loading ? "Please Wait..." : "LOGIN"}
                </button>
              </form>

              <p className="mt-4 text-center">
                New on our platform?{" "}
                <Link to="/register">Create an account</Link>
              </p>

              <div className="social-icons d-flex justify-content-center">
                <a title="GitHub">
                  <FaGithub />
                </a>
                <a title="Google">
                  <FaGoogle />
                </a>
              </div>

            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default LoginPage;
